export const CARD_CREATE_STATUS = {
    create: 'CREATE',
    confirm: "CONFIRM"
}
export const CONFIRM_DELAY_SECOND = 59

export default {
    props: {
        mko_id: {},
        user_id: {
            default: null
        }
    },
    data() {
        return {
            card_id: null,
            transaction_id: null,
            loading: false,
            interval: null,
            timeout: 0,
            code: null,
            status: CARD_CREATE_STATUS.create,
            temp_user_id: null
        }
    },
    computed: {
        CARD_CREATE_STATUS() {
            return CARD_CREATE_STATUS
        }
    },
    methods: {
        clear() {
            const {cardFormObs, confirmFormObs} = this.$refs
            this.code = null
            this.interval = null
            this.timeout = 0
            this.card_id = null
            this.transaction_id = null
            this.status = this.CARD_CREATE_STATUS.create
            this.temp_user_id = null
            if (cardFormObs) cardFormObs.reset()
            if (confirmFormObs) confirmFormObs.reset()
        },
        setTime() {
            this.timeout = CONFIRM_DELAY_SECOND;
            this.interval = setInterval(() => {
                this.timeout--
                if (this.timeout === 0) {
                    clearInterval(this.interval)
                    this.interval = null
                }
            }, 1000);
        },
    }
}